import { addOpacity } from '../../../utils/helpers';
import useTheme from '../../../utils/useTheme';

var getAlertVariantColor = function getAlertVariantColor(alertVariant) {
  switch (alertVariant) {
    case 'success':
      return 'green-300';

    case 'info':
      return 'blue-300';

    case 'warning':
      return 'yellow-300';

    case 'error':
      return 'red-300';

    case 'default':
    default:
      return 'white';
  }
};

var getAlertVariantIcon = function getAlertVariantIcon(alertVariant) {
  switch (alertVariant) {
    case 'success':
      return 'check-circle';

    case 'warning':
      return 'alert-circle';

    case 'info':
    case 'default':
    default:
      return 'info';
  }
};

var useAlertStyles = function useAlertStyles(_ref) {
  var variant = _ref.variant,
      variantBackgroundStyle = _ref.variantBackgroundStyle;
  var theme = useTheme();
  var color = getAlertVariantColor(variant);

  switch (variantBackgroundStyle) {
    case 'transparent':
      return {
        p: 2,
        align: 'center',
        icon: getAlertVariantIcon(variant),
        iconColor: color,
        border: '1px solid',
        borderColor: color,
        borderRadius: 'large',
        backgroundColor: addOpacity(theme.colors[color], 0.3)
      };

    case 'solid':
    default:
      return {
        p: 4,
        backgroundColor: 'navyblue-400',
        borderLeft: variant === 'default' ? 'none' : '4px solid',
        borderRadius: 'small',
        borderLeftColor: color,
        titleColor: color
      };
  }
};

export default useAlertStyles;